if (document.body.classList.contains('page-rewards-program')) {

	var done_flag = 0;
	var done_flag_1 = 0;
	var done_html = 0;

	var done_html2 = 0;
	setInterval(function () {
        if( done_flag == 0 || done_flag_1 == 0 ){
            if( done_flag_1 == 0 ){
                if( document.querySelector('.refer-a-friend input#reward-referral-youremail') != null ){
                    document.querySelector('.refer-a-friend input#reward-referral-youremail').setAttribute('placeholder', 'Your email address');
                }
        
                if( document.querySelector('.refer-a-friend .stamped-rewards-page-btn') != null ){
                    document.querySelector('.refer-a-friend .stamped-rewards-page-btn').textContent = 'Next';
                    done_flag_1++;
                }
            }
            if( done_flag == 0 ){
                $(".how-use-points .stamped-rewards-widget-campaigns-spendings .stamped-rewards-widget-campaign-spendings-vip").remove(); 
                if( document.querySelector('.how-use-points .stamped-rewards-widget-heading-main') != null ){
                    var headingMain = document.querySelector('.how-use-points .stamped-rewards-widget-heading-main');
                    var dataLabelSubTitle = document.querySelector('.how-use-points #stamped-rewards-widget').getAttribute('data-label-sub-title');
                    var newElement = document.createElement('p');
                    newElement.className = 'stamped-rewards-widget-text';
                    newElement.textContent = dataLabelSubTitle;
                    headingMain.parentNode.insertBefore(newElement, headingMain.nextSibling);
                    done_flag++;
                }
                if($(".stamped-customer-logged-in").is(":visible")){
                  $(".stamped-rewards-widget-buttons").addClass("static-buttons");
                  $(".how-earn-points .stamped-rewards-earnings [data-campaign-event='celebrateBirthday']").addClass("last-campaign");
                }  
            }
        }

		var hide_flag = 0;
		 if (done_html2 == 0) {
			var stampedRewardsWidgets = document.querySelectorAll('#stamped-rewards-widget');
			stampedRewardsWidgets.forEach(function (element) {
				element.classList.add('open');
				if (element.innerHTML.trim() === '') {
					hide_flag = 1;
				}
			});
		 }
		 var stampedRewardsWidgets2 = document.querySelectorAll('#stamped-rewards-widget');
		  if (hide_flag === 0 && done_html == 0) {
			  done_html2 = 1;
			  stampedRewardsWidgets2.forEach(function (element2) {
				  element2.classList.remove('open');
			  });
			  done_html++;
			  var elements = document.querySelectorAll('.how-earn-points .stamped-rewards-earnings .stamped-rewards-widget-item .stamped-rewards-widget-buttons .stamped-rewards-widget-button[data-type="login"]');
			  elements.forEach(function (element) {
				  var newDiv = document.createElement('div');
				  newDiv.classList.add('login-wrap');

				  var newParagraph = document.createElement('p');
				  newParagraph.textContent = 'Already a member?';

				  element.parentNode.insertBefore(newDiv, element);
				  newDiv.appendChild(newParagraph);
				  newDiv.appendChild(element);
			  });
		  }

	}, 500);

}